import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-container-fluid q-pb-1 q-my-1 q-text-center q-no-results-state"
}
const _hoisted_2 = { class: "q-w-100" }
const _hoisted_3 = {
  key: 0,
  class: "q-fw-normal q-text-dark q-mb-0 q-small"
}

import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useSerpResultsStore } from '@/store/SerpPage/SerpResultsStore';
import { inject } from 'vue';
import { SmartSearchTranslationsInterface } from '@/core/types';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'NoResultsInfo',
  setup(__props) {

const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!;
const serpStore = useSerpResultsStore();
const { loading, noResultsState } = storeToRefs(serpStore);

onMounted(() => {
  if (typeof window._QONizer !== 'undefined' && typeof window._QONizer?.customSmartSearchConfig?.displayNotFoundWidget === 'function') {
    window._QONizer?.customSmartSearchConfig?.displayNotFoundWidget();
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(noResultsState))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_unref(loading))
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(SmartSearchTranslations).serp.emptyResults), 1))
            : _createCommentVNode("", true),
          _cache[0] || (_cache[0] = _createElementVNode("div", { id: "noResultsWidgetPlaceholder" }, null, -1))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})